import { create } from "zustand";
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from "./localStores";

import Cookies from "js-cookie";
import { getDomain } from "../components/utils/getDomain";
const ACCESS_TOKEN = "token-pv";
/* interface AuthUser {
  accountNo: string
  email: string
  role: string[]
  exp: number
}

interface AuthState {
  auth: {
    user: AuthUser | null
    setUser: (user: AuthUser | null) => void
    accessToken: string
    setAccessToken: (accessToken: string) => void
    resetAccessToken: () => void
    reset: () => void
  }
}
 */
export const useAuthStore = create /* <AuthState> */()((set) => {
  const cookieState = Cookies.get(ACCESS_TOKEN);
  const initToken = cookieState ? cookieState : undefined;
  return {
    auth: {
      user: undefined,
      setUser: (user) =>
        set((state) => ({ ...state, auth: { ...state.auth, user } })),
      accessToken: initToken,
      setAccessToken: (accessToken) =>
        set((state) => {
          if (process.env.NODE_ENV === "production") {
            Cookies.set(ACCESS_TOKEN, accessToken, {
              expires: 1,
              path: "/",
              domain: `.${getDomain(window.location.hostname)}`,

              secure: true,
              sameSite: "None",
            });
          }

          if (process.env.NODE_ENV === "development") {
            Cookies.set(ACCESS_TOKEN, accessToken, {
              expires: 1,
              path: "/",
            });
          }
          return { ...state, auth: { ...state.auth, accessToken } };
        }),
      resetAccessToken: () =>
        set((state) => {
          if (process.env.NODE_ENV === "production") {
            Cookies.remove(ACCESS_TOKEN, {
              path: "/",
              domain: `.${getDomain(window.location.hostname)}`,
              secure: true,
              sameSite: "None",
            });
          }

          if (process.env.NODE_ENV === "development") {
            Cookies.remove(ACCESS_TOKEN);
          }

          return { ...state, auth: { ...state.auth, accessToken: undefined } };
        }),
      reset: () =>
        set((state) => {
          if (process.env.NODE_ENV === "production") {
            Cookies.remove(ACCESS_TOKEN, {
              path: "/",
              domain: `.${getDomain(window.location.hostname)}`,
              secure: true,
              sameSite: "None",
            });
          }

          if (process.env.NODE_ENV === "development") {
            Cookies.remove(ACCESS_TOKEN);
          }
          return {
            ...state,
            auth: { ...state.auth, user: undefined, accessToken: undefined },
          };
        }),
    },
  };
});
